import { Formik, Form } from "formik";
import * as Yup from "yup";
import MainLayout from "../../layout";
import { useNavigate } from "react-router-dom";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import { api } from "../../redux/apis/api";
import { FormDropDown } from "../../components/form/dropdown";
import { useState } from "react";
import { useEffect } from "react";
import { FormTextAreaField } from "../../components/form/text-area";

const CreateEmployeeRequest = () => {
  const naviagte = useNavigate();
  const [customerlist, setcustomerlist] = useState([]);
  const [addresslist, setAddresslist] = useState([]);

  const initialValues = {
    customer_id: null,
    customer_delivery_address: null,
    status: "",
    description: "",
  };

  const validationSchema = Yup.object().shape({
    description: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    api
      .post(`/employee-request/create`, values)
      .then((response) => {
        successToast(response.message);
        console.log(response, "response");
        naviagte(`/employee-request/edit/${response?.data?.data?.id}`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const fetchCustomerDropDownData = () => {
    api
      .get(`/customer/dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.customers?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setcustomerlist(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  const fetchaddressDropDownData = (customer_id) => {
    api
      .post(`/employee-request/customer-address-dropdown`, { customer_id })
      .then((res) => {
        let newArr = res?.data?.data?.addresses?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setAddresslist(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    fetchCustomerDropDownData();
  }, []);

  return (
    <MainLayout>
      <section className="h-full overflow-auto px-3">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
                <h2 className="text-xl font-semibold capitalize">
                  Employee Request - Create
                </h2>
                <div className="flex gap-3 items-center">
                  <button
                    onClick={() => naviagte("/employee-request/list")}
                    type="button"
                    className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                  >
                    Create
                  </button>
                </div>
              </div>
              <section className="w-full max-w-[40rem]">
                <div className="my-4">
                  <FormDropDown
                    name="customer_id"
                    label="customer"
                    options={customerlist}
                    onChangeExtra={(customerId) => {
                      if (customerId) {
                        fetchaddressDropDownData(customerId);
                      }
                    }}
                  />
                </div>
                <div className="my-4">
                  <FormDropDown
                    name="customer_delivery_address"
                    label="customer delivery address"
                    options={addresslist}
                  />
                </div>
                <div className="my-4">
                  <FormTextAreaField
                    name={"description"}
                    label={"description"}
                    placeholder={`Enter description`}
                    rows={3}
                  />
                </div>
              </section>
            </Form>
          )}
        </Formik>
      </section>
    </MainLayout>
  );
};

export default CreateEmployeeRequest;
